import { render, staticRenderFns } from "./MinesControls.vue?vue&type=template&id=5ba602a0&scoped=true"
import script from "./MinesControls.vue?vue&type=script&lang=js"
export * from "./MinesControls.vue?vue&type=script&lang=js"
import style0 from "./MinesControls.vue?vue&type=style&index=0&id=5ba602a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba602a0",
  null
  
)

export default component.exports